import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SectionBuilder from "../../components/sectionbuilder/SectionBuilder";
import QuestionBuilder from "../../components/questionbuilder/QuestionBuilder";
import "./QuestionnaireBuilder.css";
import axios from "axios";
import LoadingButtonText from "../../components/loadingButtonText/loadingButtonText";

const QuestionnaireBuilder = (props) => {
  const { id } = useParams();
  let navigate = useNavigate();
  // eslint-disable-next-line
  const [saveUnclickable, setSaveUnclickable] = useState(false);
  const [reusableIds, setReusableIds] = useState([]);
  const [isExitOpen, setExitOpen] = useState(false);
  const [deletedObjs, setDeletedObjs] = useState([]);
  const [loading, setLoading] = useState(id ? true : false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    props.actSidebar(false);
    if (id) {
      var userData = JSON.parse(localStorage.getItem("userData"));
      if (userData === null) {
        props.checkLoggedIn(false);
      } else {
        setLoading(true);
        axios.defaults.headers.common["Authorization"] = JSON.parse(
          localStorage.getItem("userData")
        ).token;
        axios
          .post(
            window.ajaxLink + "cloud_questionnaires/get-questionnaire-edits",
            { id }
          )
          .then((res) => {
            if (res.data.responseData) {
              setQuestionnaireState(res.data.responseData);
              var reusableObj = [];
              for (var section of res.data.responseData.sections) {
                reusableObj.push({ section_id: section.section_id });
                for (var question of section.questions) {
                  reusableObj.push({
                    section_id: section.section_id,
                    question_id: question.question_id,
                  });
                  for (var answer of question.answers) {
                    reusableObj.push({
                      section_id: section.section_id,
                      question_id: question.question_id,
                      answer_id: answer.answer_id,
                    });
                  }
                }
              }
              setReusableIds(reusableObj);
              setLoading(false);
            }
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
            if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
              props.checkLoggedIn(false);
            }
            if (
              error.response.data.errorData.message ===
              "Questionnaire does not exist!"
            ) {
              setSaveUnclickable(true);
            }
          });
      }
    }
  }, [props, id]);

  const checkForNum = (val) => {
    let reg = /^\d*(\.\d+)?$/;
    var tstreg = reg.test(val);
    if (!tstreg) {
      return false;
    } else {
      val = parseFloat(val);
      if (isNaN(val)) {
        val = 0;
      }
    }
    return val;
  };

  const [questionnaireState, setQuestionnaireState] = useState({
    questionnaire_name: "",
    questionnaire_type: "",
    top_instructions: "",
    bottom_instructions: "",
    related_problem: "",
    related_subproblem: "",
    sections: [],
  });

  const [sectionModified, setSectionModified] = useState(-1);
  const [questionsBackup, setQuestionsBackup] = useState("");
  const openCloseSections = (mod, discard) => {
    if (isInQuestion) {
      if (
        questionnaireState.sections[sectionModified].questions &&
        questionnaireState.sections[sectionModified].questions.length > 0 &&
        discard === false
      ) {
        for (var questionParam of questionnaireState.sections[sectionModified]
          .questions) {
          for (var qitem in questionParam) {
            if (
              questionParam[qitem].length === 0 &&
              qitem !== "show_condition_value" &&
              qitem !== "db_write" &&
              qitem !== "db_write_table" &&
              qitem !== "db_write_field" &&
              qitem !== "db_write_condition" &&
              qitem !== "db_write_add_update" &&
              qitem !== "answers"
            ) {
              setErrorPopUp("Please fill in all the marked fields.");
              setErrorInputs(true);
              return false;
            }
          }

          if ( questionParam.question_type === 'Subtitle' || questionParam.answers.length > 0) {
            for (var answerParam of questionParam.answers) {
              for (var aitem in answerParam) {
                if (answerParam[aitem].length === 0) {
                  setErrorPopUp(
                    "Please fill in all the marked fields for answers."
                  );
                  setErrorInputs(true);
                  return false;
                }
              }
            }
          } else {
            setErrorPopUp("You need to add at least one answer for question.");
            setErrorInputs(true);
            return false;
          }
        }
      }
      //  else {
      //   setErrorPopUp("You need to add at least one question.");
      //   setErrorInputs(true);
      //   return false;
      // }
    }

    if (discard === true) {
      var questionnaire = { ...questionnaireState };
      if (questionsBackup) {
        questionnaire.sections[sectionModified].questions =
          JSON.parse(questionsBackup);
      }
      setQuestionnaireState(questionnaire);
    } else if (discard === false) {
      setQuestionsBackup("");
    } else {
      var questionnaireSave = { ...questionnaireState };
      setQuestionsBackup(
        JSON.stringify(questionnaireSave.sections[mod].questions)
      );
    }

    setSectionModified(mod);
    setInQuestion(!isInQuestion);
  };

  const handleMainDetails = (key, value) => {
    var questionnaire = { ...questionnaireState };
    questionnaire[key] = value;
    setQuestionnaireState(questionnaire);
  };
  const addSection = () => {
    var questionnaire = { ...questionnaireState };
    var sectionModel = {
      section_number: "",
      section_name: "",
      force_newpage: "",
      fill_user_type: "",
      show_condition_question: "",
      show_condition_value: "",
      questions: [],
    };
    questionnaire.sections.push(sectionModel);
    setQuestionnaireState(questionnaire);
  };
  const handleSectionDetails = (keys, value, isNumber) => {
    var questionnaire = { ...questionnaireState };
    if (!!isNumber) {
      value = checkForNum(value);
      if (checkForNum(value) === false) {
        return false;
      }
    }
    questionnaire.sections[keys[0]][keys[1]] = value;
    setQuestionnaireState(questionnaire);
  };

  const addQuestion = (mod) => {
    var questionnaire = { ...questionnaireState };
    var questionModel = {
      question_number: "",
      question_title: "",
      question_subtitle: "",
      question_type: "",
      fill_user_type: "",
      show_condition_question: "",
      show_condition_value: "",
      db_write: "",
      db_write_table: "",
      db_write_field: "",
      db_write_condition: "",
      db_write_add_update: "",
      answers: [],
    };
    questionnaire.sections[mod].questions.push(questionModel);
    setQuestionnaireState(questionnaire);
  };
  const handleQuestionDetails = (keys, value, isNumber) => {
    var questionnaire = { ...questionnaireState };
    if (!!isNumber) {
      value = checkForNum(value);
      if (checkForNum(value) === false) {
        return false;
      }
    }
    questionnaire.sections[keys[0]].questions[keys[1]][keys[2]] = value;
    setQuestionnaireState(questionnaire);
  };

  const addAnswer = (mod) => {
    var questionnaire = { ...questionnaireState };
    var answerModel = { answer: "", answer_weight: "" };
    if (mod[2]) {
      answerModel.question_id = mod[2];
    }
    questionnaire.sections[mod[0]].questions[mod[1]].answers.push(answerModel);
    setQuestionnaireState(questionnaire);
  };
  const handleAnswerDetails = (keys, value, isNumber) => {
    var questionnaire = { ...questionnaireState };
    if (!!isNumber) {
      value = checkForNum(value);
      if (checkForNum(value) === false) {
        return false;
      }
    }
    questionnaire.sections[keys[0]].questions[keys[1]].answers[keys[2]][
      keys[3]
    ] = value;
    setQuestionnaireState(questionnaire);
  };

  const [isInQuestion, setInQuestion] = useState(false);
  const [successPopUp, setSuccessPopUp] = useState("");
  const [errorPopUp, setErrorPopUp] = useState("");
  const popupRef = useRef(errorPopUp);
  useEffect(() => {
    popupRef.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);
  const [errorInputs, setErrorInputs] = useState(false);

  const saveQuestionnaire = () => {
    setErrorPopUp("");
    setErrorInputs(false);
    for (var item in questionnaireState) {
      if (questionnaireState[item].length === 0) {
        setErrorPopUp("Please fill in all the marked fields.");
        setErrorInputs(true);
        return false;
      }
      if (questionnaireState.sections.length > 0) {
        for (var sectionParam of questionnaireState.sections) {
          for (var sitem in sectionParam) {
            if (
              sectionParam[sitem].length === 0 &&
              sitem !== "show_condition_value" &&
              sitem !== "questions"
            ) {
              setErrorPopUp(
                "Please fill in all the marked fields for sections."
              );
              setErrorInputs(true);
              return false;
            }
          }
          if (sectionParam.questions.length > 0) {
            for (var questionParam of sectionParam.questions) {
              for (var qitem in questionParam) {
                if (
                  questionParam[qitem].length === 0 &&
                  qitem !== "show_condition_value" &&
                  qitem !== "db_write" &&
                  qitem !== "db_write_table" &&
                  qitem !== "db_write_field" &&
                  qitem !== "db_write_condition" &&
                  qitem !== "db_write_add_update" &&
                  qitem !== "answers"
                ) {
                  setErrorPopUp(
                    "Please fill in all the marked fields for questions."
                  );
                  setErrorInputs(true);
                  return false;
                }
              }

              if ( questionParam.question_type == 'Subtitle' ||  questionParam.answers.length > 0) {
                for (var answerParam of questionParam.answers) {
                  for (var aitem in answerParam) {
                    if (answerParam[aitem].length === 0) {
                      setErrorPopUp(
                        "Please fill in all the marked fields for answers."
                      );
                      setErrorInputs(true);
                      return false;
                    }
                  }
                }
              } else {
                setErrorPopUp(
                  "You need to add at least one answer for each question."
                );
                setErrorInputs(true);
                return false;
              }
            }
          } else {
            setErrorPopUp(
              "You need to add at least one question for each section."
            );
            setErrorInputs(true);
            return false;
          }
        }
      } else {
        setErrorPopUp("You need to add at least one section.");
        setErrorInputs(true);
        return false;
      }
    }

    setSubmitting(true);

    var qData = { ...questionnaireState };
    qData.related_subproblem = qData.related_subproblem.trim();
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "cloud_questionnaires/save-questionnaire-edits", {
        id: id ? id : 0,
        questionnaire_data: qData,
      })
      .then((res) => {
        if (res.data.responseData) {
          setSuccessPopUp("Questionnaire");
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.errorData.message) {
          setErrorPopUp(error.response.data.errorData.message);
        }
        setErrorInputs(true);
        return false;
      }).finally(() => {
        setSubmitting(true);
      });
  };

  const [aboutToDelete, setAboutToDelete] = useState("");
  const [itemToDelete, setItemToDelete] = useState(-1);
  const [idToDelete, setIdToDelete] = useState(0);
  const setUpDeletion = (itemToDel, itemType, id) => {
    setItemToDelete(itemToDel);
    setAboutToDelete(itemType);
    if (id !== undefined) {
      setIdToDelete(typeof id === "number" ? id : parseInt(id));
    }
  };

  const handleDeletion = (proceedWithDeletion) => {
    if (
      proceedWithDeletion &&
      (itemToDelete > -1 || Array.isArray(itemToDelete))
    ) {
      var qState = { ...questionnaireState };
      if (aboutToDelete === "Section") {
        qState.sections.splice(itemToDelete, 1);
        setQuestionnaireState(qState);
      }
      if (aboutToDelete === "Question") {
        qState.sections[itemToDelete[0]].questions.splice(itemToDelete[1], 1);
        setQuestionnaireState(qState);
      }
      if (aboutToDelete === "Answer") {
        qState.sections[itemToDelete[0]].questions[
          itemToDelete[1]
        ].answers.splice(itemToDelete[2], 1);
        setQuestionnaireState(qState);
      }
      if (aboutToDelete !== "" && parseInt(idToDelete) > 0) {
        var delObjs = [...deletedObjs];
        if (aboutToDelete !== "Questionnaire" && parseInt(idToDelete) > 0) {
          delObjs.push({ [aboutToDelete]: parseInt(idToDelete) });
          setDeletedObjs(delObjs);
        }

        axios.defaults.headers.common["Authorization"] = JSON.parse(
          localStorage.getItem("userData")
        ).token;
        axios
          .post(
            window.ajaxLink + "cloud_questionnaires/delete-questionnaire-data",
            {
              id:
                typeof idToDelete === "number"
                  ? idToDelete
                  : parseInt(idToDelete),
              item: aboutToDelete,
              id_collection: reusableIds,
            }
          )
          .then((res) => {
            if (res.data.responseData) {
              if (aboutToDelete === "Questionnaire") {
                navigate("/questionnaires");
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
    setAboutToDelete("");
    setItemToDelete(-1);
    setIdToDelete(0);
  };

  const handleExit = (proceedWithSave) => {
    var hasInputs = function () {
      for (var objKey in questionnaireState) {
        if (questionnaireState[objKey].length > 0) {
          return true;
        }
      }
      return false;
    };
    if (proceedWithSave) {
      saveQuestionnaire();
    } else if (proceedWithSave === false || !hasInputs()) {
      revertQuestChanges();
      navigate("/questionnaires");
    }
    setExitOpen(!isExitOpen);
  };

  const revertQuestChanges = () => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(
        window.ajaxLink + "cloud_questionnaires/return-questionnaire-data",
        {
          id,
          deleted_objects: deletedObjs,
        }
      )
      .catch((error) => {
        console.error(error);
      });
  };

  //console.log(JSON.stringify(questionnaireState));

  return (
    <div>
      <div
        className="prog_det_top_hold vt_top"
        style={{ display: "flex", flexDirection: "column", gap: "15px" }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "row",
            gap: "15px",
            alignItems: "center",
            paddingTop: "1rem"
          }}
        >
          <div className="prog_back_icon" style={{padding: 0, margin: 0}}></div>
          {isInQuestion ? (
            <div
              onClick={() => (isInQuestion ? openCloseSections("", true) : "")}
              className="prog_det_back_text"
              style={{padding: 0, margin: 0}}
            >
              Back to Main Details
            </div>
          ) : (
            <div className="prog_det_back_text" style={{padding: 0, margin: 0}}
            onClick={() => handleExit()}>
              Back to Questionnaires
            </div>
          )}
        </div>
        <div style={{flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: '10px'}}>
        <div className="prog_det_title vt_title_reduce">
          Questionnaire Builder
        </div>
        <div
          className="prog_edit_btn prog_save_btn"
          onClick={() =>
            isInQuestion ? openCloseSections("", false) : saveQuestionnaire()
          }
        >
          <LoadingButtonText loading={submitting} text={"Save"} loadingText={"Saving"} />
        </div>
        </div>
      </div>
      {
        loading ?
        <div className="loader_full_container">
          <div className="p_load mess_p_load"></div>
        </div>
        :
      <div className="vt_overall">
        {!isInQuestion ? (
          <>
            <SectionBuilder
              questionnaireState={questionnaireState}
              handleMainDetails={handleMainDetails}
              addSection={addSection}
              openCloseSections={openCloseSections}
              handleSectionDetails={handleSectionDetails}
              errorInputs={errorInputs}
              errorPopUp={errorPopUp}
              setUpDeletion={setUpDeletion}
            />
            {id && (
              <div
                className="vt_add item_dlt_color item_dlt_last"
                onClick={() => setUpDeletion("", "Questionnaire", id)}
              >
                Delete Questionnaire
              </div>
            )}
          </>
        ) : (
          <QuestionBuilder
            questionnaireState={questionnaireState}
            sectionModified={sectionModified}
            addQuestion={addQuestion}
            handleQuestionDetails={handleQuestionDetails}
            addAnswer={addAnswer}
            handleAnswerDetails={handleAnswerDetails}
            errorInputs={errorInputs}
            errorPopUp={errorPopUp}
            setUpDeletion={setUpDeletion}
          />
        )}
      </div>
      }
      {successPopUp && (
        <div className="dlt_wrapper">
          <div className="dbl_place_on_page">
            <div className="dlt_surround">
              <div className="dlt_title">Save Confirmation</div>
              <div className="dlt_description">
                Your {successPopUp} has been successfully saved.
              </div>
              <div className="dlt_exit_btm">
                <div
                  className="dlt_exit_btn dlt_eb_scnd dlt_lone_btn"
                  onClick={() => navigate("/questionnaires")}
                >
                  OK
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {errorPopUp && (
        <div className="prog_err_hold">
          <div className="prog_err_icon"></div>
          <div className="prog_err_text">{errorPopUp}</div>
        </div>
      )}
      {isExitOpen && (
        <div className="dlt_wrapper">
          <div className="dbl_place_on_page">
            <div className="exit_surround">
              <div className="exit_primary_title">
                Are you sure you want to exit?
              </div>
              <div className="exit_explain">
                If you exit now your changes will be lost. Save your changes
                before exiting.
              </div>
              <div className="exit_btn_hold">
                <div
                  className="exit_btn exit_btn_bleak prog_det_new_btn_left"
                  onClick={() => handleExit()}
                >
                  Go back
                </div>
                <div
                  className="exit_btn exit_btn_bleak prog_det_new_btn_left"
                  onClick={() => handleExit(false)}
                >
                  Exit without saving
                </div>
                <div
                  className="exit_btn exit_btn_regular"
                  onClick={() => handleExit(true)}
                >
                  Save and Exit
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {aboutToDelete && (
        <div className="dbl_place_on_page">
          <div className="dlt_surround dlt_box">
            <div className="dlt_title">Delete Confirmation</div>
            <div className="dlt_description">
              <p>Do you want to delete this {aboutToDelete}?</p>
            </div>
            <div className="dlt_exit_btm">
              <div
                className="dlt_exit_btn dlt_eb_first"
                onClick={() => handleDeletion()}
              >
                Cancel
              </div>
              <div
                className="dlt_exit_btn dlt_eb_scnd"
                onClick={() => handleDeletion(true)}
              >
                Delete
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuestionnaireBuilder;
